export enum CustomerTypesEnum {
  BUSINESS_GST = 'business_gst',
  BUSINESS_NONE = 'business_none',
  CONSUMER = 'consumer',
  OVERSEAS = 'overseas',
}
